import { useEntityUrl, createRoute } from 'framework/routing';

export const PROCESS_ASSETS_PATH = `/processes/assets`;

export const useProcessAssetsRoute = () => {
  const baseRoutes = createRoute({ listRoute: PROCESS_ASSETS_PATH });

  return {
    ...baseRoutes,
    publishRoute: `/publish/:assetPath`,
  };
};

export const useProcessAssetsUrl = () => {
  const baseUrls = useEntityUrl({
    baseLink: PROCESS_ASSETS_PATH,
  });

  return {
    ...baseUrls,
  };
};
